// extracted by mini-css-extract-plugin
export var button = "_8v-7";
export var buttonRow = "_8v-6";
export var fadeIn = "_8v-1";
export var gradient = "_8v-0";
export var panel = "_8v-2";
export var panelIn = "_8v-3";
export var subtitle = "_8v-5";
export var title = "_8v-4";